import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import SaveIcon from '@mui/icons-material/Save';
import EditIcon from '@mui/icons-material/Edit';
import ShuffleIcon from '@mui/icons-material/Shuffle';
import { Playlist } from '@/constants/Playlist';

export const PlaylistHeader = ({
	playlist,
	onShuffle,
	onEdit,
	onDelete,
	onReorderClicked,
	isReordering,
	onSave
}) => {
	const [shuffleClicked, setShuffleClicked] = useState(false);

	const handleEdit = e => {
		e.preventDefault();
		onEdit(e, playlist);
	};
	const handleShuffle = e => {
		e.preventDefault();
		setShuffleClicked(true);
		onShuffle(e, playlist?.videos || []);

		setTimeout(() => {
			setShuffleClicked(false);
		}, 7000);
	};
	const handleSave = e => {
		e.preventDefault();
		onSave()
	}
	const handleReorder = e => {
		e.preventDefault();
		onReorderClicked(e, playlist?.videos || [])
	}
	return (
		<div className="d-flex justify-content-between align-items-center gap-2 mb-2">
			<div className="d-flex flex-row gap-1 align-content-center mb-0 ">
				<p className='playlist_name'>{playlist?.name}</p>
				<div className='d-flex' onClick={handleEdit}>{isReordering && (<EditIcon style={{ color: '#3cb4e4' }} />)}</div>
			</div>
			<div className="c-featured_box-left-b4 m-0 d-inline-flex align-items-center">
				{playlist?.type !== Playlist.FPL && (
					isReordering ? (
						<button onClick={handleEdit} className="d-flex align-content-center outline__primary__btn shuffle fw-normal small">
							<span>
								<PlaylistAddIcon style={{ color: '#3cb4e4', fontSize: '1.5rem' }} />
							</span>
							<span className="d-none d-lg-flex align-self-center m-0">Add/Remove Videos</span>
						</button>
					) : (
						<button
							onClick={handleReorder}
							className="d-inline-flex align-content-center outline__primary__btn shuffle"
							style={{
								pointerEvents: shuffleClicked ? 'none' : 'auto',
								opacity: shuffleClicked ? 0.5 : 1
							}}
						>
							<span>
								<EditIcon style={{ color: '#3cb4e4', fontSize: '1.5rem' }} />
							</span>
							<span className="d-none d-lg-flex align-self-center m-0">Edit</span>
						</button>
					)
				)}
				{!isReordering ? (
					<button onClick={!isReordering ? handleShuffle : undefined}
						className={`d-inline-flex outline__primary__btn shuffle ${isReordering ? 'disabled' : ''}`}
						style={{ pointerEvents: isReordering ? 'none' : 'auto', opacity: isReordering ? 0.5 : 1 }}>
						<span>
							<ShuffleIcon style={{ color: "#3cb4e4", fontSize: "1.5rem" }} />

						</span>
						<span className="d-none d-lg-flex align-self-center m-0">Shuffle</span>
					</button>
				) : (
					<button onClick={handleSave} className="d-inline-flex text-white align-content-center outline__primary__btn__save shuffle" style={{ backgroundColor: "#3cb4e4" }}>
						<span>
							<SaveIcon style={{ color: "white", fontSize: "1.5rem" }} />
						</span>
						<span className="d-none d-lg-flex align-self-center m-0 fw-normal">Save</span>
					</button>
				)}


			</div>
		</div>
	);
};
